module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "columns is-gapless wrapper-page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-2",
    attrs: {
      "id": "editor"
    }
  }, [_c('EditorSide', {
    ref: "editor"
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-10",
    attrs: {
      "id": "pano"
    }
  }, [_c('noscript', [_c('table', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('tr', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_c('td', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("ERROR:"), _c('br'), _c('br'), _vm._v("Javascript not activated"), _c('br'), _c('br')])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08008a58","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Editor.vue
// module id = 1069
// module chunks = 1